<div class="search-wrapper">  
  <form [formGroup]="searchForm" class="form-inline search-form collapse" id="collapseSearch">
    <input [formControl]="myControl" class="form-control form-control-sm search" type="text" placeholder="Search..."
      aria-label="Search">
    <div class="seach-item-list" *ngIf="seachItemList">
      <div class="search-item" *ngFor="let item of seachItemList">
        <div class="item" *ngIf="item.type === 'website'">
          <a href="{{baseUrl}}/web/{{item.url}};type={{item.category}};postType=websites">
            <img src="../../assets/images/websites/thumbnail/{{item.thumbnail_image}}" alt="{{item.title}}">
            <span>{{item.title}}</span>
          </a>
        </div>
        <div class="item" *ngIf="item.type === 'photography'">
          <a href="{{baseUrl}}/{{item.type}}/{{item.url}};type={{item.category}};postType=photography">
            <img src="../../assets/images/{{item.type}}/thumbnail/{{item.thumbnail_image}}" alt="{{item.title}}">
            <span>{{item.title}}</span>
          </a>
        </div>
      </div>
    </div>
  </form>
</div>